import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TicksClass } from "../type/Ticks";
import { TransportEvent } from "./TransportEvent";
/**
 * TransportRepeatEvent is an internal class used by Tone.Transport
 * to schedule repeat events. This class should not be instantiated directly.
 */

export var TransportRepeatEvent = /*#__PURE__*/function (_TransportEvent) {
  _inherits(TransportRepeatEvent, _TransportEvent);

  var _super = _createSuper(TransportRepeatEvent);

  /**
   * @param transport The transport object which the event belongs to
   */
  function TransportRepeatEvent(transport, opts) {
    var _this;

    _classCallCheck(this, TransportRepeatEvent);

    _this = _super.call(this, transport, opts);
    /**
     * The ID of the current timeline event
     */

    _this._currentId = -1;
    /**
     * The ID of the next timeline event
     */

    _this._nextId = -1;
    /**
     * The time of the next event
     */

    _this._nextTick = _this.time;
    /**
     * a reference to the bound start method
     */

    _this._boundRestart = _this._restart.bind(_assertThisInitialized(_this));
    var options = Object.assign(TransportRepeatEvent.getDefaults(), opts);
    _this.duration = new TicksClass(transport.context, options.duration).valueOf();
    _this._interval = new TicksClass(transport.context, options.interval).valueOf();
    _this._nextTick = options.time;

    _this.transport.on("start", _this._boundRestart);

    _this.transport.on("loopStart", _this._boundRestart);

    _this.context = _this.transport.context;

    _this._restart();

    return _this;
  }

  _createClass(TransportRepeatEvent, [{
    key: "invoke",
    value:
    /**
     * Invoke the callback. Returns the tick time which
     * the next event should be scheduled at.
     * @param  time  The AudioContext time in seconds of the event
     */
    function invoke(time) {
      // create more events if necessary
      this._createEvents(time); // call the super class


      _get(_getPrototypeOf(TransportRepeatEvent.prototype), "invoke", this).call(this, time);
    }
    /**
     * Push more events onto the timeline to keep up with the position of the timeline
     */

  }, {
    key: "_createEvents",
    value: function _createEvents(time) {
      // schedule the next event
      var ticks = this.transport.getTicksAtTime(time);

      if (ticks >= this.time && ticks >= this._nextTick && this._nextTick + this._interval < this.time + this.duration) {
        this._nextTick += this._interval;
        this._currentId = this._nextId;
        this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new TicksClass(this.context, this._nextTick).toSeconds());
      }
    }
    /**
     * Push more events onto the timeline to keep up with the position of the timeline
     */

  }, {
    key: "_restart",
    value: function _restart(time) {
      this.transport.clear(this._currentId);
      this.transport.clear(this._nextId);
      this._nextTick = this.time;
      var ticks = this.transport.getTicksAtTime(time);

      if (ticks > this.time) {
        this._nextTick = this.time + Math.ceil((ticks - this.time) / this._interval) * this._interval;
      }

      this._currentId = this.transport.scheduleOnce(this.invoke.bind(this), new TicksClass(this.context, this._nextTick).toSeconds());
      this._nextTick += this._interval;
      this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new TicksClass(this.context, this._nextTick).toSeconds());
    }
    /**
     * Clean up
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(TransportRepeatEvent.prototype), "dispose", this).call(this);

      this.transport.clear(this._currentId);
      this.transport.clear(this._nextId);
      this.transport.off("start", this._boundRestart);
      this.transport.off("loopStart", this._boundRestart);
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign({}, TransportEvent.getDefaults(), {
        duration: Infinity,
        interval: 1,
        once: false
      });
    }
  }]);

  return TransportRepeatEvent;
}(TransportEvent);